import React from 'react';
import { Clock, DollarSign, TrendingUp, Rocket } from 'lucide-react';
import './styles/hero.css';
import '../index.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-overlay"></div>

      <div className="hero-content">
        <h1 className="hero-title">Welcome to Precise Preps</h1>

        <p className="hero-subtitle">
          FBA prep center may present challenges, but we're here to turn it into a seamless experience for you. Choose us, and you'll:
        </p>

        <div className="hero-benefits">
          <div className="benefit-item">
            <Clock className="benefit-icon" />
            <span className="benefit-text">Save Time</span>
          </div>

          <div className="benefit-item">
            <DollarSign className="benefit-icon" />
            <span className="benefit-text">Slash Expenses</span>
          </div>

          <div className="benefit-item">
            <TrendingUp className="benefit-icon" />
            <span className="benefit-text">Make Money</span>
          </div>

          <div className="benefit-item">
            <Rocket className="benefit-icon" />
            <span className="benefit-text">Scale with Ease</span>
          </div>
        </div>

        {/* Nova seção de destaque */}
        <div className="hero-highlight">
          <p className="highlight-text">No Membership Fees</p>
          <span className="highlight-separator">•</span>
          <p className="highlight-text">No Minimum Orders</p>
        </div>

        <a href="#register" className="hero-cta">Get Started</a>
      </div>
    </section>
  );
};

export default Hero;